const GMAP_LOCATION_SUGGESTIONS_LIMIT = 2

const renderItemLabel = item => (
  item.search_group === "search_query"
    ? `${I18n.t("fe.navbar_search.search_query")}: ${item.name}`
    : item.name
)

const renderItemSuggestion = item => (
  `<a class="tt-item" ${item.url ? `href="${item.url || '#'}"` : ""}>
    ${item.search_header ? `<div class="tt-item-header">${I18n.t(`fe.navbar_search.${item.search_group}`)}</div>` : ""}
    <div class="tt-item-suggestion">
      <span class="tt-item-name">${renderItemLabel(item)}</span>
      <i class="icon caret-icon fa fa-angle-right"></i>
    </div>
  </a>`
)

const getItemSearchGroup = item => {
  if (item.model_name === "ProductTagsCategory" || item.model_name === "ProductTag") {
    return "categories"
  } else if (item.model_name === "Company") {
    return "suppliers"
  } else if (item.model_name === "Product") {
    return "products"
  } else if (item.type === "google.maps.places.AutocompletePrediction") {
    return "search_nearby"
  } else {
    return "search_query"
  }
}

const getItemUrl = item => {
  if (item.model_name === "ProductTagsCategory") {
    return st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}k/${item.id}`)
  } else if (item.model_name === "ProductTag") {
    return st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}t/${item.id}`)
  } else if (item.model_name === "Company") {
    return st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}company/${item.id}`)
  } else if (item.model_name === "Product") {
    return st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}p/${item.id}`)
  } else if (item.type === "google.maps.places.AutocompletePrediction") {
    return null
  } else {
    return st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}s?q=${encodeURIComponent(item.name)}`)
  }
}

const mapSearchResultsToSuggestions = results => {
  const searchGroups = {
    categories: false,
    products: false,
    suppliers: false,
    search_nearby: false,
    search_query: false,
  }
  return results.map(item => {
    item = { 
      ...item, 
      search_group: getItemSearchGroup(item),
      url: getItemUrl(item),
    }
    if (!searchGroups[item.search_group]) {
      searchGroups[item.search_group] = true
      item = { ...item, search_header: (item.search_group !== "search_query") }
    }
    return item
  })
}

const getSearchSuggestions = query => new Promise((resolve, reject) => {
  st.resources.search.searchAutocomplete(query).then(
    results => resolve(mapSearchResultsToSuggestions(results)),
    e => reject(e)
  )
})

let gmapAutocompleteService
const getGmapSuggestions = query => new Promise((resolve, reject) => {
  onGoogleLoad(() => {
    gmapAutocompleteService = gmapAutocompleteService || new google.maps.places.AutocompleteService()
    gmapAutocompleteService.getPlacePredictions({ input: query }, (predictions, status) => {
      if (status != google.maps.places.PlacesServiceStatus.OK) { 
        resolve([])
      } else {
        const results = predictions.map(prediction => ({
          type: "google.maps.places.AutocompletePrediction",
          name: prediction.description,
          place_id: prediction.place_id,
        }))
        resolve(mapSearchResultsToSuggestions(results))
      }
    })
  })
})

const initNavbarSearch = $container => {
  const $searchInput = $container.find(".navbar-search-input")

  const toggleLoadingDimmer = visible => $container.toggleClass("is-loading", visible)
  
  const requestSearchSuggestions = (query, syncResults, asyncResults) => {
    toggleLoadingDimmer(true)
    getSearchSuggestions(query).then(
      results => { toggleLoadingDimmer(false); asyncResults(results) },
      () => { toggleLoadingDimmer(false) }
    )
  }
  const requestSearchSuggestionsDebounced = _.debounce(requestSearchSuggestions, 300)

  const requestGmapSuggestions = (query, syncResults, asyncResults) => {
    getGmapSuggestions(query).then(asyncResults)
  }
  const requestGmapSuggestionsDebounced = _.debounce(requestGmapSuggestions, 300)

  $searchInput.typeahead({
    minLength: 3,
    hint: false
  }, [
    {
      source: (query, syncResults) => {
        syncResults(mapSearchResultsToSuggestions([{ name: query }]))
      },
      display: item => item.name,
      templates: {
        suggestion: renderItemSuggestion
      },
    },
    {
      async: true,
      source: requestSearchSuggestionsDebounced,
      display: item => item.name,
      templates: {
        suggestion: renderItemSuggestion
      },
      limit: 100
    },
    {
      async: true,
      source: requestGmapSuggestionsDebounced,
      display: item => item.name,
      templates: {
        suggestion: renderItemSuggestion
      },
      limit: GMAP_LOCATION_SUGGESTIONS_LIMIT,
    },
  ])

  $searchInput.bind("typeahead:select", (event, item) => {
    if (item.url) {
      window.location.href = item.url
    } else if (item.type === "google.maps.places.AutocompletePrediction") {
      const placesService = new google.maps.places.PlacesService(document.createElement("div"))
      placesService.getDetails({ placeId: item.place_id }, (result, status) => {
        if (status != google.maps.places.PlacesServiceStatus.OK) { return }
        const { lat, lng } = result.geometry.location.toJSON()
        window.location.href = st.urlWithCurrentQuery(location.origin + `/s?lq=${encodeURIComponent(item.name)}&lat=${lat}&lng=${lng}`)
      })
    }
  })
}

$(document).ready(() => {
  $(".navbar-search-input-wrapper").each((i, element) => {
    initNavbarSearch($(element))
  })
})



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/navbar_search.js